<div class="notyf__toast has-background-danger error-notification">
  <div class="notyf__wrapper is-align-items-flex-start">
    <article class="notyf__message error-notification__message is-flex-grow-1">
      @if (title()) {
        <h3 class="notyf__title" [ngClass]="options().titleClass">
          {{ title() | translate }}
        </h3>
      }
      <p class="has-text-weight-bold is-overflow-y-auto" [ngClass]="options().messageClass">
        {{ message() }}
      </p>

      <button
        type="button"
        fino-button
        small
        inverted
        class="error-notification__copy is-danger mt-3"
        [icon]="copied() ? 'Check 1' : 'Copy Paste 1'"
        [label]="copied() ? 'notification.copied' : 'notification.copy'"
        (click)="copyMessage($event)"
      ></button>
    </article>

    <button
      type="button"
      class="error-notification__close delete ml-2"
      [attr.aria-label]="'notification.close' | translate"
      (click)="remove()"
    ></button>
  </div>
</div>
